import React, { useContext, useEffect, useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/three";
import { useGLTF } from "@react-three/drei";
import CurrentContext from "./CurrentContext";
import useSetMaterialFinish from "./useTextureCustom";
import { handleExportGLTF } from "./utils/jsHelpers";
import { useControls } from "leva";
import { Deg0, Deg90CCW } from "./utils/AnimaonSprings";

export default function Model_samish() {
  const { nodes, materials, scene } = useGLTF("models/samish.glb");
  const [finishes, setFinishes] = useState({});
  const [tileFinishes, setTileFinishes] = useState({});

  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    secondDoor,
    colorScheme,
    setcolorScheme,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    refrigerator,
    refrigeratorType,
    setRefrigeratorType,
    animation,
    tileColorScheme,
    setTileColorScheme,
    sink,
    groutColor,
    setGroutColor,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (siding === "Quartzite") {
      if (colorScheme === "Sandstone Tan SR12") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-sandstone-tan.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-sandstone-tan.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
      if (colorScheme === "Misty Gray SR16") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-misty-gray.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
    } else if (siding === "Faux Rock") {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-gray.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-brown.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
    } else if (siding === "No Siding") {
      setFinishes({
        diffuseMap: "../textures/big/no-siding-1k.jpeg",
        displacementMap: null,
        // normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
        normalScale: [1, 1],
        repeat: [5, 5],
        // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
      });
    }
    {
      if (tileColorScheme === "Chocolate") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-chocolate.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#928272",
        });
      }
      if (tileColorScheme === "Civic Sand") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-civic-sand.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#e5e3dec7",
        });
      }
      if (tileColorScheme === "Notable beige") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-notable-beige.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#eeebe5",
        });
      }
      if (tileColorScheme === "Park Lane Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-park-lane-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#c6ccd4",
        });
      }
      if (tileColorScheme === "Union smoke") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-union-smoke.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#8c95a2",
        });
      }
      if (tileColorScheme === "Iron Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-iron-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
      if (tileColorScheme === "No Tile") {
        setTileFinishes({
          diffuseMap: "../textures/big/no-siding-1k.jpeg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
    }
  }, [siding, colorScheme, tileColorScheme]);

  useSetMaterialFinish(materials.siding, finishes, setLoading);
  useSetMaterialFinish(
    materials.countertop_with_sink_frame,
    groutColor,
    setLoading
  );
  useSetMaterialFinish(materials.island_top, tileFinishes, setLoading);

  const { rotation_Grill } = useSpring({
    rotation_Grill: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 500 : 0,
  });

  const { rotation_Side_burner } = useSpring({
    rotation_Side_burner: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 0 : 500,
  });

  return (
    <group dispose={null}>
      {/* side_burner */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.side_burner_base.geometry}
        material={materials.side_burner_base}
        position={[0,0.001,0]}
        visible={sideBurner ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.side_burner_knob_logo.geometry}
          material={materials.side_burner_knob_logo}
        />
        <animated.group
          position={[0.243, 1.003, -0.197]}
          rotation={rotation_Side_burner}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes.side_burner_top.geometry}
            material={materials.side_burner_top}
            // position={[0.243, 1.003, -0.197]}
          />
        </animated.group>
      </mesh>

      {/* umbrella_hole */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole_1.geometry}
        material={materials.umbrella_hole}
        visible={umbrellHole ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole_2.geometry}
        material={materials.hole_part}
        visible={umbrellHole ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole.geometry}
        material={materials.umbrella_hole}
        visible={umbrellHole ? true : false}
      />

      {sink ? (
        <>
          {/* 15"_sink */}
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['15"_sink'].geometry}
            material={materials['15"_sink']}
            // visible={sink === true ? true : false}
          />
          {tileColorScheme === "No Tile" && (
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.metal_top_with_sink.geometry}
              material={materials.island_top}
            />
          )}
          {/* countertop_with_sink_base */}
          {!(tileColorScheme === "No Tile") && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.countertop_with_sink_base.geometry}
                material={materials.island_top}
                // visible={sink === true ? true : false}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.countertop_with_sink_frame.geometry}
                material={materials.countertop_with_sink_frame}
                // visible={sink === true ? true : false}
              />
            </>
          )}
        </>
      ) : (
        <>
          {tileColorScheme === "No Tile" && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_top.geometry}
                material={materials.island_top}
              />
            </>
          )}
          {/* countertop_without_sink_base */}
          {!(tileColorScheme === "No Tile") && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.countertop_without_sink_base.geometry}
                material={materials.island_top}
                // visible={sink === false ? true : false}
              >
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.countertop_without_sink_frame.geometry}
                  material={materials.countertop_with_sink_frame}
                />
                {/* <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.countertop_without_sink_top.geometry}
                        material={materials.island_top}
                      /> */}
              </mesh>
            </>
          )}
        </>
      )}
      {tileColorScheme === "No Tile" && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.metal_side.geometry}
            material={materials.metal_side}
          />
        </>
      )}

      {/* bottle_opener_1 */}
      {siding !== "Faux Rock" && bottleOpener && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.bottle_opener_1.geometry}
            material={materials.bottle_opener_1}
            // visible={siding === "Quartzite" && bottleOpener ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.bottle_opener_2_logo.geometry}
            material={materials.bottle_opener_2_logo}
          />
        </>
      )}
      {/* bottle_opener_2 */}
      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes.bottle_opener_2.geometry}
        material={materials.bottle_opener_2}
        visible={siding === "Quartzite" && bottleOpener ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bottle_opener_2_logo.geometry}
          material={materials.bottle_opener_2_logo}
        />
      </mesh> */}

      {siding === "Faux Rock" ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.plug_1_1.geometry}
            material={materials.plug_1_1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.net_1_frame.geometry}
            material={materials.net_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.net_1.geometry}
            material={materials.net_1}
          />
          {refrigeratorType !== "None" ? (
            <>
              {/* <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.side_81_with_outdoor_rated_fridge.geometry}
                    material={materials.siding}
                    visible={
                      refrigeratorType === "Outdoor Rated Fridge" ? true : false
                    }
                  /> */}
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.side_81_with_sink.geometry}
                material={materials.siding}
                scale={[0.959, 1, 1]}
                visible={refrigeratorType === "Standard Fridge" ? true : false}
              />
            </>
          ) : (
            <>
              {/* side_81_without_fridge */}
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.side_81_without_fridge.geometry}
                material={materials.siding}
                scale={[0.959, 1, 1]}
              />
            </>
          )}

          <mesh
            castShadow
            receiveShadow
            geometry={nodes.skirting_2.geometry}
            // material={materials.skirting_2}
            material={materials.siding}
          />
        </>
      ) : (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.plug_1_1.geometry}
            material={materials.plug_1_1}
            position={[-0.025, 0, 0]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.net_2_frame.geometry}
            material={materials.net_2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.net_2.geometry}
            material={materials.net_1}
          />
          {refrigeratorType !== "None" ? (
            <>
              {/* <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.side_84_with_outdoor_rated_fridge.geometry}
                    material={materials.siding}
                    scale={[0.959, 1, 1]}
                    visible={
                      refrigeratorType === "Outdoor Rated Fridge" ? true : false
                    }
                  /> */}
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.side_84_with_sink.geometry}
                material={materials.siding}
                scale={[0.959, 1, 1]}
                // visible={
                //   refrigeratorType === "Standard Fridge" ? true : false
                // }
              />
            </>
          ) : (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.side_84_without_fridge.geometry}
                material={materials.siding}
                scale={[0.959, 1, 1]}
              />
            </>
          )}

          <mesh
            castShadow
            receiveShadow
            geometry={nodes.skirting_2_2.geometry}
            // material={materials.skirting_2_2}
            material={materials.siding}
          />
        </>
      )}

      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes.plug_1.geometry}
        material={materials.plug_1}
        position={[0.2,0,0]}
      /> */}

      {/* 30" Door/Propane Drawer Combo */}
      {door === '30" Door/Propane Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["door-door_propane_drawer_combo_1"].geometry}
            material={materials["door-door_propane_drawer_combo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["door-door_propane_drawer_combo_2"].geometry}
            material={materials["door-door_propane_drawer_combo_back_part"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.door_propane_drawer_combo_handle.geometry}
            material={materials.door_propane_drawer_combo_handle}
          />
        </>
      )}

      {/* 30" Door/Drawer Combo */}
      {door === '30" Door/Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['door-30"_double_drawer_door_combo_1'].geometry}
            material={materials['door-30"_double_drawer_door_combo']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['door-30"_double_drawer_door_combo_2'].geometry}
            material={materials['door-30"_double_drawer_door_combo_back_part']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.double_drawer_door_combo_handle.geometry}
            material={materials.double_drawer_door_combo_handle}
          />
        </>
      )}
      {/* door-30"_double_door */}
      <group
        visible={door === '30" Double Door' ? true : false}
        position={[-0.872, 0.122, 0.331]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['door-30"_double_door_1'].geometry}
          material={materials['door-30"_double_door']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['door-30"_double_door_2'].geometry}
          material={materials['door-30"_double_door_back_part']}
        />
      </group>

      {/* grill-30_lonestar_grill_hea */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_lonestar_grill_head"].geometry}
        material={materials["grill-30_lonestar_grill_head"]}
        visible={grill === '30" Lonestar' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_alpha"].geometry}
          material={materials["grill-30_lonestar_grill_head_alpha"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_inner_black"].geometry}
          material={materials["grill-30_lonestar_grill_head_inner_black"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_inner_grill"].geometry}
          material={materials["grill-30_lonestar_grill_head_inner_grill"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knoob_logo"].geometry
          }
          material={
            materials["grill-30_lonestar_grill_head_top_frame_knoob_logo"]
          }
        >
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_knoob_logo_1"]
                .geometry
            }
            material={
              materials["grill-30_lonestar_grill_head_top_frame_knoob_logo_2"]
            }
          />
        </mesh>
        <animated.group
          position={[-0.154, 1.108, 0.021]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_side_frame"]
                .geometry
            }
            material={
              materials["grill-30_lonestar_grill_head_top_frame_side_frame"]
            }
            // position={[-0.154, 1.108, 0.021]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_glass"].geometry}
              material={materials["grill-30_lonestar_grill_head_glass"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_handle"].geometry}
              material={materials["grill-30_lonestar_grill_head_handle"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_inner_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_inner_frame"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_top_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_top_frame"]}
            />
          </animated.mesh>
        </animated.group>
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_logo_frame"].geometry
          }
          material={materials["grill-30_lonestar_grill_head_top_logo_frame"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knob_1"].geometry
          }
          material={materials["grill-30_lonestar_grill_head_top_frame_knob_1"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knob_2"].geometry
          }
          material={materials["grill-30_lonestar_grill_head_top_frame_knob"]}
        />
      </mesh>

      {/* grill_30_agnus */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.grill_30_agnus.geometry}
        material={materials.grill_30_agnus}
        visible={grill === '30" Angus' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agngus_inner_grill"].geometry}
          material={materials["grill-30_agngus_inner_grill"]}
        />
        <animated.group
          position={[-0.113, 1.113, 0.025]}
          rotation={rotation_Grill}
        >
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agngus_inner_grill_side_frame"].geometry}
            material={materials["grill-30_agngus_inner_grill_side_frame"]}
            // position={[-0.113, 1.113, 0.025]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_clock"].geometry}
              material={materials["grill-30_agnus_clock"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_handle"].geometry}
              material={materials["grill-30_agnus_handle"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top"].geometry}
              material={materials["grill-30_agnus_top"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_frame"].geometry}
              material={materials["grill-30_agnus_top_frame"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_glass"].geometry}
              material={materials["grill-30_agnus_top_glass"]}
            />
          </animated.mesh>
        </animated.group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_logo"].geometry}
          material={materials["grill-30_agnus_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_alpha"].geometry}
          material={materials["grill-30_agnus_stove_knob_alpha"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_logo"].geometry}
          material={materials["grill-30_agnus_stove_knob_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_wire"].geometry}
          material={materials["grill-30_agnus_wire"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_1"].geometry}
          material={materials["grill-30_agnus_stove_knob"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_2"].geometry}
          material={materials["grill-30_agnus_stove_knob_1"]}
        />
      </mesh>

      {/* fridge logic */}
      {refrigerator === true && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_1.geometry}
            material={materials.refrigerator}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_2.geometry}
            material={materials.refrigerator_frame}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator_3.geometry}
            material={materials["Brahma-door_propane_drawer_combo_handle.002"]}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_1.geometry}
            material={materials.outdoor_rated_fridge}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_2.geometry}
            material={materials.outdoor_rated_fridge_2}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_3.geometry}
            material={materials.outdoor_rated_fridge_frame}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_4.geometry}
            material={materials["grill-30_bull_griddle_top"]}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.outdoor_rated_fridge_5.geometry}
            material={materials["Brahma-door_propane_drawer_combo_handle.001"]}
            visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
          />
        </>
      )}

      {/* <mesh
        castShadow
        receiveShadow
        geometry={nodes["new-_griddle_head"].geometry}
        material={materials["new- griddle_head"]}
        visible={grill === '30" Bull Griddle Head' ? true : false}
        position={[-0.477, -0.034, -0.03]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["new-_griddle_head_logo"].geometry}
          material={materials["new- griddle_head_logo.002"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["new-_griddle_head_logo_frame"].geometry}
          material={materials["new- griddle_head_logo_frame"]}
        />
        <animated.group position={[0, 1.082, -0.067]} rotation={rotation_Grill}>
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes["new-_griddle_head_top"].geometry}
            material={materials["new- griddle_head_top"]}
            // position={[0, 1.082, -0.067]}
          />
        </animated.group>
      </mesh> */}
      {grill === '30" Bull Griddle Head' ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_1"].geometry}
            material={materials["grill-30_bull_griddle_1"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_2"].geometry}
            material={materials["grill-30_bull_griddle"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_knoob_logo"].geometry}
            material={materials["grill-30_bull_griddle_knoob_logo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_logo"].geometry}
            material={materials["grill-30_bull_griddle_logo"]}
          />
          <animated.group
            position={[-0.123, 1.054, -0.097]}
            rotation={rotation_Grill}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_bull_griddle_top"].geometry}
              material={materials["grill-30_bull_griddle_top"]}
              // position={[-0.123, 1.054, -0.097]}
            />
          </animated.group>
        </>
      ) : null}
    </group>
  );
}
